import React from 'react';
import { NavLink } from 'react-router-dom';
import { StyledBrand, StyledBrandLogo, StyledBrandTitle } from './styled';

export interface IBrandProps {
  title: string;
  logo: string;
  size?: 'md' | 'lg';
  link?: boolean;
  locale: string;
}

const Brand = ({ title, logo, size, link = true, locale }: IBrandProps): JSX.Element => (
  <StyledBrand {...(link && { tag: NavLink, to: `/${locale}/`, exact: true })} data-test-id="NavBarBrand">
    <StyledBrandLogo src={logo} alt={title} size={size} data-test-id="NavBarBrand-logo" />
    <StyledBrandTitle data-test-id="NavBarBrand-title">{title}</StyledBrandTitle>
  </StyledBrand>
);

export default Brand;
